import { Box, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import React from 'react'
import EastIcon from '@mui/icons-material/East'
import { type } from 'os'
import { Image } from '@/components'
type PropItemMenu = {
  item: ICategoryMenu
}

export default function ItemMenuMega({ item }: PropItemMenu) {
  return (
    <Stack spacing={2}>
      <Box
        sx={{
          fontSize: 18,
          fontWeight: 600,
          color: 'primary.main',
          textTransform: 'uppercase',
          mb: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {item?.icon_image && (
          <Stack sx={{ width: '14px', height: '14px' }}>
            <Image src={item.icon_image || ''} alt={item.name} />
          </Stack>
        )}
        <Link
          href={item.url_path ? '/' + item.url_path : '#'}
          style={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center',
          }}
        >
          {item.name}
          <EastIcon fontSize="small" />
        </Link>
      </Box>
      <Stack spacing={1}>
        {item.children &&
          item.children.length > 0 &&
          item.children.map((menu, idx) => (
            <Link
              key={idx}
              href={menu.url_path ? '/' + menu.url_path : '#'}
              style={{ position: 'relative', display: 'inline-block' }}
            >
              <Typography
                component={'span'}
                sx={{
                  fontSize: '14px',
                  color: 'primary.main',
                  textTransform: 'uppercase',
                  position: 'relative',
                  display: 'inline-block',
                  paddingBottom: '1px',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: 0,
                    height: '1px',
                    backgroundColor: 'primary.main',
                    transition: 'width 0.3s ease-in-out',
                  },
                  '&:hover::after': {
                    width: '100%',
                    left: 0,
                  },
                }}
              >
                {menu.name}
              </Typography>
            </Link>
          ))}
      </Stack>
    </Stack>
  )
}
